import * as React from 'react';
import Measure from 'react-measure';
import {StatelessComponent, cloneElement} from 'react';

export interface INavTabsWrapperProps {
  children?: any;
  onResize: (width: number) => void;
}

export const NavTabsMeasure: StatelessComponent<INavTabsWrapperProps> = ({children, onResize}) => (
  <Measure
    bounds
    onResize={({bounds}) => onResize(bounds.width)}
  >
    {({measureRef}) => cloneElement(children, {ref: measureRef})}
  </Measure>
);
